<template>
  <v-layout row wrap>
    <!-- If movies exist in wishlist -->
    <v-flex xs12 v-if="list && list.length">
      <!---------------------- MOVIES LOOP STARTS HERE -------------------------->

      <v-card flat class="white--text" v-for="(item,index) in films" :key="index">
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <!-- Movie posters -->
            <v-flex xs5 sm3 md2 lg1>
              <v-img
                v-if="item.film.thumbs.length"
                :src="item.film.thumburls[item.film.thumbs[0]]"
                height="205px"
                contain
              ></v-img>
              <v-img v-else src="@/assets/no-image-available.jpg" height="170px" contain></v-img>
            </v-flex>

            <!-- Movie title -->
            <v-flex xs7 sm9 md10 lg11>
              <v-card-title primary-title class="headline">{{item.film.title}}</v-card-title>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <!-- Delete button -->
            <v-btn small icon color="red" @click="selected_item = item, dialog = true">
              <v-icon small>{{ $vuetify.icons.rms_delete }}</v-icon>
            </v-btn>&ensp;&ensp;
            <!-- Count of rights and countries -->
            <span>{{ item.rights.length }} {{$t('rms.rights.label')}}&ensp;|&ensp;</span>
            <span>{{item.countries.length}} {{$t('rms.countries.label')}}</span>
            <v-spacer></v-spacer>

            <!-- Arrow icon -->
            <v-btn icon @click="show = !show,current_film_id = item.film.id">
              <v-icon>{{ show && current_film_id == item.film.id ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
            </v-btn>
          </v-card-actions>

          <!----------------------- SLIDER STARTS ------------------------------->

          <v-slide-y-transition>
            <v-card-text class="pb-0" v-if="show && current_film_id == item.film.id">
              <!-- If any one, either rights or countries -->
              <div v-if="item.rights.length || item.countries.length">
                <!-- If exclusive filter is applied -->
                <div
                  v-if="item.exclusive == 1"
                  class="primary--text"
                >{{$t('rms_guested_requested_for_exclusive_rights')}}</div>

                <!------------------------------------------------------------------
                  SINGLE LOOP TO DISPLAY BOTH RIGHTS AND COUNTRIES OF SELECTED FILM
                ------------------------------------------------------------------->

                <div
                  v-for="(item,index) in makeArrayOfFilmrights(item.rights,item.countries)"
                  :key="index+'filmright'"
                >
                  <div v-if="item.filmright.length">
                    <v-subheader class="pl-0 orange--text">
                      <span>{{item.label}}</span>&ensp;
                      <v-divider light></v-divider>
                    </v-subheader>
                    <div
                      xs12
                      v-for="(data,index) in getTags(item.filmright,item.filmright_type)"
                      :key="'item'+index"
                    >
                      <v-layout row wrap>
                        <v-flex xs1 class="font-weight-bold">{{ data.alphabet }}</v-flex>
                        <v-flex xs11>
                          <span v-for="(record,index) in data.records" :key="index+'record'">
                            <span class="subheading">
                              {{record}}
                              <span v-if="index+1 < data.records.length">,&ensp;</span>
                            </span>
                          </span>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>

                  <!-------------------------------------------------------------
                    SINGLE LOOP ENDS HERE
                  ------------------------------------------------------------->
                </div>
              </div>
              <!-- In nothing applied then assume that requested for all. -->
              <div v-else>
                {{$t('rms.wishlist.requested_for_all_label')}}
                <div
                  v-if="item.exclusive == 1"
                  class="primary--text"
                >{{$t('rms_guested_requested_for_exclusive_rights')}}</div>
              </div>
            </v-card-text>
          </v-slide-y-transition>

          <!------------------------- SLIDER ENDS HERE ---------------------->
        </v-container>
        <v-divider></v-divider>
      </v-card>

      <!------------------------ MOVIES LOOP ENDS HERE ---------------------->
    </v-flex>

    <!-- If movies does not exist in wishlist. -->
    <v-flex xs12 v-else>
      <NotFound icon="rms_folder" headline="oops_text" msg="empty_wishlist_msg"></NotFound>
    </v-flex>

    <!-- Submit button -->
    <v-flex xs12 v-if="list && list.length">
      <v-container fluid>
        <v-btn color="green" block @click="submit()">{{$t('rms.submit.wishlist.btn.label')}}</v-btn>
      </v-container>
    </v-flex>

    <!-- Confirmation dialog -->
    <v-flex xs12>
      <ConfirmationDialog
        v-if="dialog"
        :dialog="dialog"
        :message="$t('warning_before_remove_from_wishlist')"
        @confirm="removeFromWishlist(),dialog = false"
        @cancel="selected_item = null, dialog = false"
      ></ConfirmationDialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import ConfirmationDialog from "@/components/dialogBox/Confirmation";
import i18n from "@/i18n";
import NotFound from "@/components/NotFound";
import { doOrderAlphabetically } from "@/helper";

export default {
  data() {
    return {
      dialog: false,
      panel: [true],
      selected_item: null,
      show: false,
      current_film_id: null
    };
  },

  components: {
    ConfirmationDialog,
    NotFound
  },

  mounted() {
    this.setToolbarHeader();
    this.getWishlist();
  },

  computed: {
    ...mapGetters({
      list: "wishlist/getList",
      selected_company_id: "company/getSelected"
    }),
    films() {
      return this.getFilms(this.list);
    }
  },

  methods: {
    async getWishlist() {
      await this.$store.dispatch("wishlist/list");
    },

    getFilms(list) {
      let films = [];
      list.forEach(element => {
        let obj = {};
        obj.film = this.getFilm(element.film_id);
        obj.rights = element.rights;
        obj.countries = element.countries;
        obj.exclusive = element.exclusive;
        films.push(obj);
      });
      return films;
    },

    getTags(tags, type) {
      let tag_names = this.$store.getters["tag/getTagsfromIds"](tags, type).map(
        tag => {
          return tag.name;
        }
      );
      return doOrderAlphabetically(tag_names);
    },

    getFilm(film_id) {
      return this.$store.getters["film/getFilmFromId"](film_id);
    },

    getTagName(tag_id, tag_type) {
      var tag = this.$store.getters["tag/getTag"](tag_id, tag_type);
      return tag.name;
    },

    async submit() {
      try {
        await this.$store.dispatch("wishlist/submit");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: this.$t("wishlist_submitted_successfully"),
          color: "green"
        });
      }
    },

    async removeFromWishlist(item) {
      await this.$store.dispatch("wishlist/remove", {
        film: {
          film_id: this.selected_item.film.id,
          rights: this.selected_item.rights,
          countries: this.selected_item.countries,
          exclusive: this.selected_item.exclusive
        }
      });
    },

    async setToolbarHeader() {
      await this.$store.dispatch("app/setToolbarHeader", {
        header: i18n.t("rms.toolbar.header.your_wishlist")
      });
    },

    makeArrayOfFilmrights(rights, countries) {
      let data = [
        {
          filmright: rights,
          filmright_type: this.DEFINES.TAG_TYPE.FOR_RIGHTS,
          label: this.$t("rms.rights.label")
        },
        {
          filmright: countries,
          filmright_type: this.DEFINES.TAG_TYPE.FOR_FILM_COUNTRIES,
          label: this.$t("rms.countries.label")
        }
      ];
      return data;
    }
  }
};
</script>

<style>
.full-length-content {
  text-overflow: unset;
  white-space: normal;
}
</style>

